import { computed, signal } from "@preact/signals";
import { currencyFormater } from "@components/WalletForm/models/products";
import { total } from "./cart";

export const FREE_SHIPPING_DEFAULT_AMOUNT = 100;

export const freeShippingAmount = signal<number>(FREE_SHIPPING_DEFAULT_AMOUNT);

export const hasFreeShipping = computed(
  () => total.value >= freeShippingAmount.value,
);

export const progressToFreeShipping = computed(() =>
  hasFreeShipping.value
    ? 100
    : Math.floor((total.value * 100) / freeShippingAmount.value),
);

export const amountLeftForFreeShipping = computed(() =>
  currencyFormater?.format(Math.max(freeShippingAmount.value - total.value, 0)),
);

export const formatedFreeShippingAmount = computed(() =>
  currencyFormater?.format(freeShippingAmount.value),
);
